import angular from 'angular';

angular.module('cloudX').directive('timeTablesEnabled', [
  'dataCache',
  function(dataCache) {
    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        dataCache.ready().then(function() {
          const enabled = dataCache.getArray('employeeTimeTables');
          if (!enabled) element.remove();
        });
      },
    };
  },
]);
